[
  {
    "label": "Deutsch",
    "value": "de",
    "order": 1,
    "isoCode": "de",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "label": "English (GB)",
    "value": "en",
    "order": 4,
    "isoCode": "en",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "label": "Français",
    "value": "fr",
    "order": 6,
    "isoCode": "fr",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "label": "Italiano",
    "value": "it",
    "order": 7,
    "isoCode": "it",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "label": "Español",
    "value": "es",
    "order": 8,
    "isoCode": "es",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "nl",
    "order": 9,
    "label": "Nederlands",
    "isoCode": "nl",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "da",
    "order": 10,
    "label": "Dansk",
    "isoCode": "da",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "sv",
    "order": 11,
    "label": "Svenska",
    "isoCode": "sv",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "no",
    "order": 12,
    "label": "Norsk",
    "isoCode": "nb",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "fi",
    "order": 13,
    "label": "Suomi",
    "isoCode": "fi",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "hu",
    "order": 14,
    "label": "Magyar",
    "isoCode": "hu",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "pt",
    "order": 15,
    "label": "Português",
    "isoCode": "pt",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "ru",
    "order": 16,
    "label": "русский",
    "isoCode": "ru",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "sk",
    "order": 17,
    "label": "slovenčina",
    "isoCode": "sk",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "cs",
    "order": 18,
    "label": "čeština",
    "isoCode": "cs",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "pl",
    "order": 19,
    "label": "polski",
    "isoCode": "pl",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "el",
    "order": 20,
    "label": "Ελληvικά",
    "isoCode": "el",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "ro",
    "order": 21,
    "label": "Română",
    "isoCode": "ro",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "label": "Türkçe",
    "value": "tr",
    "order": 23,
    "isoCode": "tr",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "hr",
    "order": 24,
    "label": "Hrvatski",
    "isoCode": "hr",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "sr",
    "order": 25,
    "label": "Srpski",
    "isoCode": "sr",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "label": "汉语",
    "value": "zh",
    "order": 31,
    "isoCode": "zh",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "bg",
    "order": 32,
    "label": "Български",
    "isoCode": "bg",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "lv",
    "order": 33,
    "label": "Latviešu",
    "isoCode": "lv",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "lt",
    "order": 34,
    "label": "Lietuvių",
    "isoCode": "lt",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "et",
    "order": 35,
    "label": "Eesti",
    "isoCode": "et",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "sl",
    "order": 36,
    "label": "Slovenski",
    "isoCode": "sl",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "label": "English (USA)",
    "value": "us",
    "order": 37,
    "isoCode": "en-US",
    "tecDocLanguage": false,
    "portalLanguage": true
  },
  {
    "value": "qb",
    "order": 38,
    "label": "English AUS",
    "isoCode": "en-AU",
    "tecDocLanguage": true,
    "portalLanguage": false
  },
  {
    "value": "is",
    "order": 39,
    "label": "Íslenska",
    "isoCode": "is",
    "tecDocLanguage": true,
    "portalLanguage": false
  },
  {
    "value": "qc",
    "order": 40,
    "label": "Português BR",
    "isoCode": "pt-BR",
    "tecDocLanguage": true,
    "portalLanguage": false
  },
  {
    "value": "ja",
    "order": 41,
    "label": "日本語",
    "isoCode": "ja",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "ar",
    "order": 42,
    "label": "عربي",
    "isoCode": "ar",
    "tecDocLanguage": true,
    "portalLanguage": false
  },
  {
    "value": "he",
    "order": 43,
    "label": "עברית",
    "isoCode": "he",
    "tecDocLanguage": true,
    "portalLanguage": false
  },
  {
    "value": "qd",
    "order": 44,
    "label": "Español MEX",
    "isoCode": "es-MX",
    "tecDocLanguage": true,
    "portalLanguage": false
  },
  {
    "value": "th",
    "order": 45,
    "label": "ภาษาไทย",
    "isoCode": "th",
    "tecDocLanguage": true,
    "portalLanguage": false
  },
  {
    "value": "ko",
    "order": 46,
    "label": "한국어",
    "isoCode": "ko",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "ms",
    "order": 47,
    "label": "Bahasa Melayu",
    "isoCode": "ms",
    "tecDocLanguage": true,
    "portalLanguage": false
  },
  {
    "value": "uk",
    "order": 48,
    "label": "Українська",
    "isoCode": "uk",
    "tecDocLanguage": true,
    "portalLanguage": true
  },
  {
    "value": "vi",
    "order": 49,
    "label": "Tiếng việt",
    "isoCode": "vi",
    "tecDocLanguage": true,
    "portalLanguage": false
  },
  {
    "value": "id",
    "order": 51,
    "label": "Bahasa Indonesia",
    "isoCode": "id",
    "tecDocLanguage": true,
    "portalLanguage": false
  }
]